import {inject, Injectable} from '@angular/core';
import {BaseModalApiService} from "../../../../../../../core/components/modals/services/base-modal-api.service";
import {ProductCardApiService} from "../../../../services-api/product-card-api.service";
import {RecordTableApiService} from "../../../../../../../core/services-api/record-table-api.service";
import {RecordUpdateRequestParams} from "../../../../../../../core/types/records-table.types";
import {GetDataInModalParams} from "../../../../types/product-card-modals.types";
import {unitEconomicsCalculationsResourceType} from "../configs/unit-economics-calculations-config";
import {
  CreateUnitEconomicsCalculationData,
  UnitEconomicsCalculationData
} from "../types/unit-economics-calculations.types";
import {
  AttachProductCardFileParams,
  DeleteFileParams,
  GetFilesParams
} from "../../../../types/product-card-files.types";
import {ProductCardFilesApiService} from "../../../../services-api/product-card-files-api.service";
import {UnitEconomicsCalculationsFile} from "../types/unit-economics-calculations-file.types";

@Injectable({
  providedIn: 'root'
})
export class UnitEconomicsCalculationsService {
  private baseModalApiService: BaseModalApiService = inject(BaseModalApiService);
  private productCardApiService: ProductCardApiService = inject(ProductCardApiService);
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);
  private productCardFilesApiService: ProductCardFilesApiService = inject(ProductCardFilesApiService);

  public createUnitEconomicsCalculation(params: CreateUnitEconomicsCalculationData): Promise<UnitEconomicsCalculationData> {
    return new Promise((resolve, reject) => {
      this.baseModalApiService.createDataInModal<CreateUnitEconomicsCalculationData, UnitEconomicsCalculationData>(params, unitEconomicsCalculationsResourceType.path).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public updatedRecordField<T>(params: RecordUpdateRequestParams): Promise<T> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.updateRecord<T>(params).subscribe({
        next: (recordData: T) => resolve(recordData),
        error: (error) => reject(error)
      });
    });
  }

  public getDataInModal<T>(technicalParametersId: number): Promise<Array<T>> {
    const params: GetDataInModalParams = {
      path: unitEconomicsCalculationsResourceType.path,
      queryParams: { technicalParametersId: technicalParametersId }
    };

    return new Promise((resolve, reject) => {
      this.productCardApiService.fetchDataInModal<T>(params).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public getFiles(getFilesParams: GetFilesParams): Promise<Array<UnitEconomicsCalculationsFile>> {
    return new Promise((resolve, reject) => {
      this.productCardFilesApiService.fetchFiles<UnitEconomicsCalculationsFile>(getFilesParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public deleteFile(deleteFileParams: DeleteFileParams): Promise<void> {
    return new Promise((resolve, reject) => {
      this.productCardFilesApiService.deleteFile(deleteFileParams).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }

  public attachFile<T>(attachProductCardFileParams: AttachProductCardFileParams): Promise<T> {
    return new Promise((resolve, reject) => {
      this.productCardFilesApiService.attachFile<T>(attachProductCardFileParams).subscribe({
        next: (data: T) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }
}
